/**
 * 301-equivalent redirects for consolidated/deduped blog posts.
 * Losing slug -> winning slug. Applied client-side via <Navigate replace>.
 * Losing slugs are removed from sitemap automatically (not in data arrays).
 */
export const blogRedirects: Record<string, string> = {
  // Consolidations (Step 3)
  "does-ms-fatigue-come-and-go": "how-long-does-ms-fatigue-last",
  "can-you-have-ms-without-fatigue": "what-does-ms-fatigue-feel-like",
  "managing-ms-fatigue": "ms-fatigue-management-complete-guide",
  "cognitive-fatigue-vs-physical-fatigue-ms": "brain-fog-ms-cognitive-fatigue",
  "ms-flare-fatigue-vs-everyday-fatigue": "what-does-ms-fatigue-feel-like",
  "ms-fatigue-invisible-symptom": "ms-fatigue-management-complete-guide",
  "ms-fatigue-vs-depression": "emotional-fatigue-ms-feelings-cost-energy",
  "mindfulness-for-ms-fatigue": "mindfulness-meditation-ms-fatigue",
  "hydration-and-ms-fatigue": "dehydration-worsens-ms-fatigue",
  "seasonal-patterns-ms-fatigue": "weather-changes-ms-fatigue",
  "ms-fatigue-seasonal-adaptation": "weather-changes-ms-fatigue",
  "energy-conservation-techniques-ms": "pacing-strategies-chronic-fatigue-ms",
  "afternoon-energy-crash-ms": "pacing-strategies-chronic-fatigue-ms",
  "ms-fatigue-anxiety-cycle": "emotional-fatigue-ms-feelings-cost-energy",
  "ms-fatigue-hormonal-changes": "menstrual-cycle-ms-fatigue",
};
